/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FrontApplicationListenPodcastModel } from './FrontApplicationListenPodcastModel';
import {
    FrontApplicationListenPodcastModelFromJSON,
    FrontApplicationListenPodcastModelFromJSONTyped,
    FrontApplicationListenPodcastModelToJSON,
} from './FrontApplicationListenPodcastModel';

/**
 * 
 * @export
 * @interface FrontApplicationListenPodcastsModel
 */
export interface FrontApplicationListenPodcastsModel {
    /**
     * Počet stránek
     * @type {number}
     * @memberof FrontApplicationListenPodcastsModel
     */
    pages: number;
    /**
     * Celkový počet
     * @type {number}
     * @memberof FrontApplicationListenPodcastsModel
     */
    count: number;
    /**
     * Epizody
     * @type {Array<FrontApplicationListenPodcastModel>}
     * @memberof FrontApplicationListenPodcastsModel
     */
    result: Array<FrontApplicationListenPodcastModel>;
}

/**
 * Check if a given object implements the FrontApplicationListenPodcastsModel interface.
 */
export function instanceOfFrontApplicationListenPodcastsModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pages" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function FrontApplicationListenPodcastsModelFromJSON(json: any): FrontApplicationListenPodcastsModel {
    return FrontApplicationListenPodcastsModelFromJSONTyped(json, false);
}

export function FrontApplicationListenPodcastsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationListenPodcastsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pages': json['pages'],
        'count': json['count'],
        'result': ((json['result'] as Array<any>).map(FrontApplicationListenPodcastModelFromJSON)),
    };
}

export function FrontApplicationListenPodcastsModelToJSON(value?: FrontApplicationListenPodcastsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pages': value.pages,
        'count': value.count,
        'result': ((value.result as Array<any>).map(FrontApplicationListenPodcastModelToJSON)),
    };
}

